<template>
  <div class="freight-dangerous">
    <div
      class="form-row freight-row"
      v-for="(line, index) in lines"
      :key="line.id"
    >
      <div class="form-group col-sm-24 col-md-24 col-lg-18 mb-0">
        <label>Contains</label>
        <un-selector
          @changed="updatedDangerousGood($event, index, freightIndex)"
          :newDangerousGoods="dangerousGood"
          :initialDangerousGoods="dangerousGoods"
          :lineIndex="index"
          :selected="line.product"
          @showForm="showForm"
        ></un-selector>
        <div
          v-if="errors.has('sizecopy-' + freightIndex + '-' + index)"
          class="invalid-feedback"
          :class="{
            block: errors.has('sizecopy-' + freightIndex + '-' + index)
          }"
        >
          Please select dangerous good at first
        </div>
        <div
          v-if="errors.has('product-' + freightIndex + '-' + index + '.id')"
          class="invalid-feedback"
          :class="{
            block: errors.has('product-' + freightIndex + '-' + index + '.id')
          }"
        >
          Please select a valid product
        </div>

        <div
          v-if="flashPointError"
          style="display:block"
          class="invalid-feedback"
        >
          Please update the flashpoint, please click
          <span
            style="color: #409EFF; cursor: pointer; text-decoration: underline;"
            @click="showForm(line.product)"
            >here</span
          >
          to update the flashpoint
        </div>
      </div>

      <div class="form-group col-sm-8 col-md-8 col-lg-2 mb-0">
        <label>Number</label>
        <select
          class="form-control"
          v-model="line.quantity"
          :class="{
            'is-invalid': errors.has('amount-' + freightIndex + '-' + index)
          }"
          :name="'amount-' + freightIndex + '-' + index"
          v-validate="'required'"
        >
          <option v-for="number in (1, 100)" :key="number">{{ number }}</option>
        </select>
        <div
          v-show="errors.has('amount-' + freightIndex + '-' + index)"
          class="invalid-feedback"
        >
          Please enter a numeric amount
        </div>
      </div>

      <div class="form-group col-sm-16 col-md-16 col-lg-4 mb-0">
        <label>Type of package</label>
        <div v-if="!line.product">
          <input
            class="form-control"
            type="number"
            :class="{
              'is-invalid': errors.has('sizecopy-' + freightIndex + '-' + index)
            }"
            placeholder="Select dangerous good"
            :name="'sizecopy-' + freightIndex + '-' + index"
            v-validate="'required'"
            @keydown="validateDgAmount($event)"
          />
          <div
            v-show="errors.has('sizecopy-' + freightIndex + '-' + index)"
            class="invalid-feedback"
          >
            Please select dangerous good at first
          </div>
        </div>

        <div v-else>
          <select
            class="form-control"
            v-model="line.size"
            :class="{
              'is-invalid': errors.has('size-' + freightIndex + '-' + index)
            }"
            :name="'size-' + freightIndex + '-' + index"
            v-validate="'required'"
          >
            <option
              v-for="size in line.product.sizes.data"
              :key="size.id"
              :value="size"
              >{{ parseFloat(size.amount) }} {{ size.unit }}</option
            >
          </select>
          <div
            v-show="errors.has('size-' + freightIndex + '-' + index)"
            class="invalid-feedback"
          >
            Please select the size
          </div>
        </div>
      </div>

      <!-- <div class="form-group col-sm-8 col-md-8 col-lg-2 mb-0">
                <input type="text" class="form-control" placeholder="4" v-model="line.amount"
                :class="{ 'is-invalid': errors.has('quantity-'+freightIndex+'-'+index) }" :name="'quantity-'+freightIndex+'-'+index" v-validate="'required|decimal'">
                <div v-show="errors.has('quantity-'+freightIndex+'-'+index)" class="invalid-feedback">
                    Please enter a numeric value
                </div>
            </div>

            <div class="form-group col-sm-8 col-md-8 col-lg-2 mb-0">
                <select class="form-control" v-model="line.unit"
                :class="{ 'is-invalid': errors.has('unit-'+freightIndex+'-'+index) }" :name="'unit-'+freightIndex+'-'+index" v-validate="'required'">
                    <option value="Kg">Kg</option>
                    <option value="L">Litres</option>
                    <option value="g">g</option>
                    <option value="ml">ml</option>
                </select>
                <div v-show="errors.has('unit-'+freightIndex+'-'+index)" class="invalid-feedback">
                    Please select the unit
                </div>
            </div> -->

      <a
        href="#"
        class="dg-row-delete"
        @click.prevent="lines.splice(index, 1)"
        v-show="lines.length > 1"
      >
        <i class="far fa-minus-circle"></i>
        <span class="hidden-lg-up">Remove row</span>
      </a>
    </div>

    <hr class="mt-2 mb-4 hidden-lg-up" />

    <div class="text-center">
      <button class="btn btn-link" type="button" @click="$emit('addLine')">
        <i class="far fa-plus-circle"></i> Add another row
      </button>
    </div>

    <dangerous-goods-form
      v-if="formShown"
      :showing="formShown"
      :product="product"
      @cancelled="formCancelled()"
      @submitted="formSubmitted"
    ></dangerous-goods-form>
  </div>
</template>

<script>
import DangerousGoodsForm from "../../dangerous-goods/DangerousGoodsForm";
import UnSelector from "./UnSelector";

export default {
  name: "dangerous-goods",
  components: { DangerousGoodsForm, UnSelector },
  props: ["dangerousGoods", "lines", "freightIndex"],
  inject: ["$validator"],

  data() {
    return {
      formShown: false,
      product: null,
      addingProductForLineIndex: null,
      dangerousGood: null,
      flashPointError: false
    };
  },

  mounted() {
    // console.log("lines", this.lines)
  },

  methods: {
    updatedDangerousGood(dangerousGood, index, freightIndex) {
      if (
        dangerousGood.good.flashPoint == "" ||
        dangerousGood.good.flashPoint == null
      ) {
        this.flashPointError = true;
        // this.errors.add({
        //         field: 'placeholdererror',
        //         msg: "Please update the dangerous good"
        //     });
      } else {
        this.errors.remove("placeholdererror");
        this.flashPointError = false;
      }

      Event.$emit(
        "removeError",
        "product-" + freightIndex + "-" + index + ".id"
      );

      this.lines[index].product = dangerousGood.good;

      let sizes = [];

      if (dangerousGood.text != "") {
        sizes = dangerousGood.good.sizes.data.filter(size => {
          if (size.code !== null) {
            if (
              size.code.toUpperCase().includes(dangerousGood.text.toUpperCase())
            ) {
              return true;
            }
          }
        });
      }

      if (sizes && sizes.length > 0) {
        this.lines[index].size = sizes[0];
      } else {
        this.lines[index].size = this.lines[index].product.sizes.data[0];
      }

      if (this.flashPointError == false) {
        // Event.$emit('removeError', 'placeholdererror');
      }
    },

    showForm(product = null, index = null) {
      if (product) {
        this.product = product;
      }

      if (index !== null) {
        this.addingProductForLineIndex = index;
      }

      this.formShown = true;
    },

    formCancelled() {
      this.product = null;
      this.formShown = false;
    },

    formSubmitted(dangerousGood = null) {
      this.product = null;
      this.formShown = false;

      if (this.addingProductForLineIndex !== null) {
        this.lines[this.addingProductForLineIndex].product = dangerousGood;
      }
      //   console.log(dangerousGood);

      Event.$emit("loadDangerousGoods");
    },

    validateDgAmount(e) {
      if (
        (e.key >= "0" && e.key <= "9") ||
        ["-", ",", ".", "e"].includes(e.key)
      ) {
        e.preventDefault();
      }
    }
  }
};
</script>
